import {useEffect} from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Avatar from '@mui/material/Avatar';
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import { HiUserRemove } from "react-icons/hi";
import { Controller } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import TextField from '@mui/material/TextField';
import swal from 'sweetalert';
import {fetchCambiarSuccess, selectEmpleadosIsSuccess,selectEmpleadosMessage} from "./../../../redux/Empleados/EmpleadosSlice";
import {useDispatch, useSelector} from "react-redux";
import { endpoints } from '../../../redux/config';
const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
};

const DesvincularEmpleado = ({ open : { active, empleado }, setOpen, handleDesvincularEmpleado, setAddRequestStatus, cleanfilter }) => {
	
	// ? HOOK-DISPATCH
	const dispatch = useDispatch();

	// ? HOOK-FORM
	const { 
		register, 
		handleSubmit, 
		formState: { errors }, 
		control,
		setValue,
		reset
	} = useForm(
	{
		defaultValues:{
			empleadoDesvinculado: {
				id: 0,
				empleadoId: 0,
				fecha: new Date(),
				motivo: "",
				comentarios: ""
			}
		}
	});

	// ? HOOK-SELECTOR
    const empleadosIsSuccess = useSelector(selectEmpleadosIsSuccess);
    const empleadoMessage = useSelector(selectEmpleadosMessage);

	const onSubmit = ( { empleadoDesvinculado }) => {
		handleDesvincularEmpleado(empleadoDesvinculado);
	};

	// ? HOOK-EFFECT DE ALERTAS
    useEffect(() => {

		if(empleadosIsSuccess ==='success' && empleadoMessage.length > 0){
			swal("Exitoso!", empleadoMessage, "success");
			handleClose();
			setAddRequestStatus('idle');
            cleanfilter();
			dispatch(fetchCambiarSuccess());
		}
		else if(empleadosIsSuccess ==='error' && empleadoMessage.length > 0){
			swal("Error!", empleadoMessage, "error");
			setAddRequestStatus('idle');
			dispatch(fetchCambiarSuccess());
		}

	},[empleadosIsSuccess, empleadoMessage])

	useEffect(() => {
	  if(Object.keys(empleado).length > 0){
		setValue('empleadoDesvinculado.empleadoId', empleado.id)
	  }
	}, [empleado])
	

	const handleClose = () => {
		setOpen({ active: false, empleado: {}});
		reset();
	};

	return (
		<Modal
			open={active}
			onClose={handleClose}
			aria-labelledby="parent-modal-title"
			aria-describedby="parent-modal-description"
		>
			<Box sx={{ ...style, width: 700 }}>
				<form onSubmit={handleSubmit(onSubmit)}>
					<div className="container">
						<div className="row">
							<h3 className="text-primary-mem text-center">DESVINCULAR EMPLEADO</h3>
						</div>
						<div className="row">
							<hr />
						</div>
						<div className="row ">
							<div className="col-md-3 text-center align-self-center">
								<Avatar
									sx={{
										width: 130,
										height: 130,
										marginLeft: 0,
										border: 'solid',
										borderWidth: 1,
										borderColor: '#003876',
                                        borderRadius:3
									}}
									alt={`${empleado.nombres} ${empleado.apellidos} `}
									src={`${endpoints.fetchEmpleadoImagen}${empleado?.codigoEmpleado}.jpg?${new Date().getTime()}`}
									variant="square"
								/>
								<label className="codigoEmpleado">{empleado.codigoEmpleado}</label>
							</div>
							<div className="col-md-9">
								<div className="row text-center text-primary-mem">
									<h3>{`${empleado.nombres} ${empleado.apellidos} `}</h3>
								</div>
								<div className="row">
									<div className="col">
										<div className="form-group">
											<label className="fw-bold">Motivo</label>
											<select {...register("empleadoDesvinculado.motivo",{required:"El motivo es requerido"})} className="form-control">
												<option value={''}>Elegir Motivo</option>
												<option value={'Renuncia'}>Renuncia</option>
												<option value={'Destitución'}>Destitución</option>
												<option value={'Contrato vencido'}>Contrato vencido</option>
												<option value={'Fallecimiento'}>Fallecimiento</option>
												<option value={'Pensión'}>Pensión</option>
											</select>
                                            <p className='text-danger'>{errors?.empleadoDesvinculado?.motivo?.message}</p>
										</div>
									</div>
									<div className="col">
										<div className="form-group">
											<label className="fw-bold">Fecha Desvinculación</label>
											<Controller
												control={control}
                                                className="mb-3"
												name="empleadoDesvinculado.fecha"
												render={({ field }) => (
													<LocalizationProvider dateAdapter={AdapterDateFns}>
														<DatePicker
															inputFormat='dd/MM/yyyy'
															label={' '}
															mask="__/__/____"
															value={field.value}
															onChange={(e) => field.onChange(e)}
															renderInput={(params) => (
																<TextField
																	height={10}
																	className="form-control"
																	style={{ height: 10 }}
																	{...params}
																/>
															)}
														/>
													</LocalizationProvider>
												)}
											/>
                                             <p className='text-danger mt-3'>{errors?.empleadoDesvinculado?.fecha?.message}</p>
										</div>
									</div>
								</div>
								<div className="row mb-3">
									<div className="form-group">
										<label className="fw-bold">Descripción</label>
										<textarea {...register("empleadoDesvinculado.comentarios")} rows={4} className="form-control" />
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="d-flex justify-content-center">
								<button type="submit" className="btn btn-primary-mem me-3">
									Desvincular
									<HiUserRemove style={{ fontSize: 22, marginLeft: 1 }} />
								</button>
								<button type="button" className="btn btn-danger " onClick={handleClose}>
									Cancelar
									<NotInterestedIcon
									className="ms-1"
									/>
								</button>
							</div>
						</div>
					</div>
				</form>
			</Box>
		</Modal>
	);
};

export default DesvincularEmpleado;
